import { getLanguage, getLocalStorage, getUser } from './func';
import config from './config';

// Only a short-lived in-memory snapshot of the originating feed. It is never
// serialized into history/localStorage and cannot cross accounts or filters.
const snapshots = new Map();
const lifetime = 5 * 60 * 1000;
let sequence = 0;
export const feedViewerContext = () => {
  const user = getUser();
  return JSON.stringify([
    user?.id || null,
    user?.country_code || null,
    getLanguage(),
    getLocalStorage(config.token),
  ]);
};
const context = () => JSON.stringify([feedViewerContext(), getLocalStorage(config.area) || config.areaType.all]);

// Settings can invalidate cards without changing the account/filter key (for
// example, hiding or clearing all opinions). Never restore those old snapshots.
export function invalidateFeedSnapshots() {
  snapshots.clear();
}

export function rememberFeedForSearch(feed) {
  const key = `${Date.now()}-${++sequence}`;
  snapshots.set(key, { feed, context: context(), expires: Date.now() + lifetime });
  while (snapshots.size > 2) snapshots.delete(snapshots.keys().next().value);
  return key;
}

export function recallFeedFromSearch(key, reactionId) {
  const saved = snapshots.get(key);
  if (!saved || saved.expires < Date.now() || saved.context !== context()) {
    snapshots.delete(key);
    return null;
  }
  return Number(saved.feed.currentNews?.id) === Number(reactionId) ? saved.feed : null;
}
